module.exports = __webpack_public_path__ + "img/ai.ff248715.png";